import { Button, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import socket, { IResponse } from '../../socket';
import IChannel from './IChannel';
import EditIcon from '@mui/icons-material/Edit';
import MessageIcon from '@mui/icons-material/Message';
import { Link } from 'react-router-dom';

const columns: GridColDef[] = [
    { field: 'id', headerName: 'ایدی', width: 70 },
    {
        field: 'image',
        headerName: 'عکس',
        renderCell: (params: GridRenderCellParams) => <img className="w-12 h-12 rounded-md object-cover" alt="" src={params.row.image} />
    },
    { field: 'name', headerName: 'نام', flex: 1 },
    { field: 'type', headerName: 'نوع', width: 90 },
    { field: 'lang', headerName: 'زبان', width: 40 },
    {
        field: 'action',
        headerName: 'عملیات',
        sortable: false,
        renderCell: (params: GridRenderCellParams) => {
            return (
                <Stack direction='row'>
                    <IconButton component={Link} to={`/channel/${params.row.id}/edit`} color='primary'><EditIcon/></IconButton>
                    <IconButton component={Link} to={`/channel/${params.row.id}`}color='success'><MessageIcon/></IconButton>
                </Stack>
            )
        }
            
    },
];


export default function Channels() {
    const [rows, setRows] = useState<IChannel[]>([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up("sm"));

    useEffect(() => {
        socket.emit('channel:all', null, (data: IResponse<IChannel[]>) => {
            setLoading(false);
            if (data.success) {
                setRows(data.result);
            }
        });
    }, [])
    return (
        <div className="p-4 pb-0">
            <div className="flex mb-2 items-center">
                <Typography className="grow">{t('channels')}</Typography>
                <Button component={Link} to='/channel/new' variant='contained' startIcon={<AddCircleOutlineRoundedIcon />}>{t('new_channel')}</Button>
            </div>
            <DataGrid
                autoHeight
                columnVisibilityModel={{
                    id: matches,
                    type: matches,
                    lang: matches,
                }}
                loading={loading}
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[10, 25, 50, 100]}
            />
        </div>
    )
}

